import React from "react"
import Img from "gatsby-image"

const Image = ({ sharp, image }) => {
  return sharp && sharp.extension !== "svg" && sharp.extension !== "gif" ? (
    <Img
      fluid={sharp.childImageSharp.fluid}
      alt={image.alt}
      imgStyle={{ objectFit: "contain" }}
    />
  ) : image ? (
    <div className="gatsby-image-wrapper">
      <img src={image.url} alt={image.alt} />
    </div>
  ) : (
    ""
  )
}

export default Image
